/** Serialize a server-authorized integer parameter without rounding or coercion. */
export function integerParameter(value: string, allowed: readonly string[]): number {
  if (!allowed.includes(value) || !/^(0|[1-9]\d*)$/.test(value)) {
    throw new Error("integer parameter is not an allowed canonical value");
  }
  const exact: unknown = JSON.parse(value);
  if (typeof exact !== "number" || !Number.isSafeInteger(exact)) {
    throw new Error("integer parameter exceeds exact JSON integer range");
  }
  // The API requires StrictInt. Conversion is exact only after both checks.
  return exact;
}
